export const ADMINISTRATOR = 'cpmt-admin-nss';
export const GENERAL = 'General';

export const READ_ONLY_EMAIL = 'nss-read-only';
